document.addEventListener("DOMContentLoaded", () => {
  const overlay = document.getElementById("champion-modal-overlay");
  const modal = document.getElementById("champion-design-modal");
  const openBtn = document.getElementById("open-champion-designer");
  const closeBtn = document.getElementById("close-champion-designer");
  const nextBtn = document.getElementById("champion-next");
  const prevBtn = document.getElementById("champion-prev");

  const steps = Array.from(document.querySelectorAll(".champion-step"));
  const progressItems = Array.from(
    document.querySelectorAll(".champion-progress-item")
  );

  const collectionCards = Array.from(
    document.querySelectorAll(".champion-choice-card")
  );

  const optionGroups = Array.from(
    document.querySelectorAll(".champion-option-grid")
  );

  if (
    !overlay ||
    !modal ||
    !openBtn ||
    !closeBtn ||
    !nextBtn ||
    !prevBtn ||
    !steps.length
  ) {
    return;
  }

  let currentStep = 0;

  const formData = {
    collection: "",
    metal: "",
    goldColour: "",
    stone: "",
    ringFace: ""
  };

  function openModal() {
    overlay.classList.add("active");
    document.body.style.overflow = "hidden";
    showStep(currentStep);
  }

  function closeModal() {
    overlay.classList.remove("active");
    document.body.style.overflow = "";
  }

  function showStep(index) {
    currentStep = index;

    steps.forEach((step, stepIndex) => {
      step.classList.toggle("active", stepIndex === index);
    });

    progressItems.forEach((item, itemIndex) => {
      item.classList.toggle("active", itemIndex === index);
    });

    prevBtn.style.visibility = index === 0 ? "hidden" : "visible";

    nextBtn.textContent =
      index === steps.length - 1
        ? "Send Design Brief on WhatsApp →"
        : "Continue →";

    const stepContainer = document.getElementById(
      "champion-step-container"
    );

    if (stepContainer) {
      stepContainer.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }

  function showMessage(message) {
    window.alert(message);
  }

  function validateStepOne() {
    if (!formData.collection) {
      showMessage("Please select a Champion Ring collection.");
      return false;
    }

    return true;
  }

  function validateStepTwo() {
    const missing = [];

    if (!formData.metal) missing.push("metal");
    if (!formData.goldColour) missing.push("gold colour");
    if (!formData.stone) missing.push("stone");
    if (!formData.ringFace) missing.push("ring face");

    if (missing.length) {
      showMessage(
        `Please select your ${missing.join(", ")} before continuing.`
      );

      return false;
    }

    return true;
  }

  function getFieldValue(id) {
    const field = document.getElementById(id);

    return field ? field.value.trim() : "";
  }

  function sendToWhatsApp() {
    const title = getFieldValue("champion-title");
    const engraving = getFieldValue("champion-engraving");
    const budget = getFieldValue("champion-budget");
    const notes = getFieldValue("champion-notes");

    const designerCheckbox = document.getElementById(
      "champion-designer"
    );

    const designerSuggestions =
      designerCheckbox && designerCheckbox.checked ? "Yes" : "No";

    if (!budget) {
      showMessage("Please select your preferred budget.");
      return;
    }

    const message = [
      "*Champion Ring Design Request*",
      "",
      `*Collection:* ${formData.collection || "Not selected"}`,
      `*Metal:* ${formData.metal || "Not selected"}`,
      `*Gold Colour:* ${formData.goldColour || "Not selected"}`,
      `*Stone:* ${formData.stone || "Not selected"}`,
      `*Ring Face:* ${formData.ringFace || "Not selected"}`,
      "",
      `*Front Title:* ${title || "Not provided"}`,
      `*Side Engraving:* ${engraving || "Not provided"}`,
      `*Budget:* ${budget}`,
      `*Additional Notes:* ${notes || "Not provided"}`,
      `*Designer Suggestions:* ${designerSuggestions}`,
      "",
      "I will attach any inspiration images manually in WhatsApp."
    ].join("\n");

    /*
      Replace the number below with your WhatsApp number.

      Format:
      Country code + mobile number
      No plus sign, spaces or dashes.

      Example India:
      919876543210
    */
    const whatsappNumber = "918884440713";

    if (whatsappNumber.includes("X")) {
      showMessage(
        "Please add your Carat Legacy WhatsApp number inside champion-design-modal.js."
      );

      return;
    }

    const whatsappUrl =
      `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

    window.open(whatsappUrl, "_blank", "noopener,noreferrer");
  }

  openBtn.addEventListener("click", openModal);
  closeBtn.addEventListener("click", closeModal);

  overlay.addEventListener("click", event => {
    if (event.target === overlay) {
      closeModal();
    }
  });

  document.addEventListener("keydown", event => {
    if (event.key === "Escape" && overlay.classList.contains("active")) {
      closeModal();
    }
  });

  collectionCards.forEach(card => {
    card.addEventListener("click", () => {
      collectionCards.forEach(item => {
        item.classList.remove("active");
      });

      card.classList.add("active");
      formData.collection =
        card.dataset.value ||
        card.querySelector("h4")?.textContent.trim() ||
        "";
    });
  });

  optionGroups.forEach(group => {
    const fieldName = group.dataset.field;
    const buttons = Array.from(
      group.querySelectorAll(".champion-option")
    );

    buttons.forEach(button => {
      button.addEventListener("click", () => {
        buttons.forEach(item => {
          item.classList.remove("active");
        });

        button.classList.add("active");

        if (fieldName) {
          formData[fieldName] = button.textContent.trim();
        }
      });
    });
  });

  nextBtn.addEventListener("click", () => {
    if (currentStep === 0 && !validateStepOne()) {
      return;
    }

    if (currentStep === 1 && !validateStepTwo()) {
      return;
    }

    if (currentStep < steps.length - 1) {
      showStep(currentStep + 1);
      return;
    }

    sendToWhatsApp();
  });

  prevBtn.addEventListener("click", () => {
    if (currentStep > 0) {
      showStep(currentStep - 1);
    }
  });

  showStep(0);
});